// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { EndpointSourceSchema } from '../inputTypeSchemas/EndpointSourceSchema'
import { SignalOriginSchema } from '../inputTypeSchemas/SignalOriginSchema'
import { AssetTagSchema } from '../inputTypeSchemas/AssetTagSchema'

/////////////////////////////////////////
// ENDPOINT SCHEMA
/////////////////////////////////////////

export const EndpointSchema = z.object({
  sources: EndpointSourceSchema.array(),
  signalCheckCompletedByOrigin: SignalOriginSchema.array(),
  assetTags: AssetTagSchema.array(),
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  credentialsIds: z.string().array(),
  isPubliclyAccessible: z.boolean().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  description: z.string().nullable(),
  servers: z.string().array(),
  url: z.string(),
  host: z.string(),
  path: z.string(),
  port: z.number().int().nullable(),
  graphqlOperationName: z.string().nullable(),
  soapOperationName: z.string().nullable(),
  xmlOperationName: z.string().nullable(),
  xmlOperationDisplayName: z.string().nullable(),
  mcpOperationName: z.string().nullable(),
  grpcServiceName: z.string().nullable(),
  grpcMethodName: z.string().nullable(),
  hash: z.string(),
  codeGraphId: z.string().nullable(),
  graphCheckFailed: z.boolean().nullable(),
  graphCheckFailedReason: z.string().nullable(),
  isOutdated: z.boolean().nullable(),
  harEntryId: z.string().nullable(),
  harEntryIds: z.string().array(),
  webpageIds: z.string().array(),
  aiFlowGraphId: z.string().nullable(),
})

export type Endpoint = z.infer<typeof EndpointSchema>

export default EndpointSchema;
